import { jsonParse } from '@utils/json';
import { identity } from 'lodash-es';

export const hasLocalizationDebug = (): boolean => {
  try {
    const raw = localStorage.getItem('USER_PREFERENCES') as string;
    const json = jsonParse<{ localizationDebug: boolean }>(raw);
    return json?.localizationDebug || false;
  } catch (err) {
    return false;
  }
};

export const DEBUG_STRING = '@@@@@@';

/** No-op translation function for strings that should not be translated */
export const notrans = identity;
